@if ((existingTrafficDeviationLoaded$ | async) !== true) {
  <fieldset>
    <div class="form-group search-input">
      <label class="label-above" for="search">{{ 'Search' | translate }}</label>
      <div class="search-input__input-wrapper" [class.error]="shouldShowAffectedError">
        <input id="search"
          [formControl]="search"
          (keyup.enter)="search.value && selectSingleResult()"
          (keyup.esc)="closeSearchResults()"
          (keyup.arrowDown)="onSearchInputKeyDown($event)"
          autocomplete="off"
          placeholder="{{ 'Search' | translate }} {{ 'route' | translate }}, {{ 'Stop' | translate | lowercase }} {{ 'or' | translate }} {{ 'stop platform' | translate }}"
          click-stop-propagation />
          @if ({value: searchLoader$ | async}; as searchLoader) {
            @if (!search.value && !searchLoader.value) {
              <app-svg-icon
                class="search suffix"
                [path]="'assets/icons/search.svg'"
                >
              </app-svg-icon>
            }
            @if (searchLoader.value) {
              <places-spinner class="suffix"></places-spinner>
            }
          }
      </div>
      @if (stopSearchResults$ | async; as stopSearchResults) {
        @if (stopSearchResults?.length) {
          <div
            class="search-results"
            (clickOutside)="closeSearchResults()"
            #searchResultsContainer>
            @for (
              result of stopSearchResults; track trackByStopIdentity($index, result)) {
              <input type="checkbox" [id]="getResultCheckboxId(result)" [checked]="result.selected">
              <div class="result" (click)="onClickToggleStopSearchResult(result)">
                <div class="stop-title">
                  <p class="name caption">
                    {{ result.description }} {{ result.platformCode }}
                  </p>
                  <div class="region-info">
                    <i class="fa-solid fa-warehouse region-icon"></i>
                    <span class="region-name">{{ result.hastusRegion }}</span>
                  </div>
                </div>
                @if (result.stopSearchLoader) {
                  <places-spinner></places-spinner>
                }
                @if (result.effectedRoutes?.length) {
                  <div class="effected-routes">
                    @for (route of result.effectedRoutes; track trackByKey.bind(this, 'templateTripId')($index, route)) {
                      <span class="route" [title]="route.firstStopDestinationSign">
                        {{ route.routeName }}
                      </span>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      }
      @if (lineSearchResults$ | async; as lineSearchResults) {
        @if (lineSearchResults?.length) {
          <div
            class="search-results"
            (clickOutside)="closeLineSearchResults()"
            #searchResultsContainer>
            <div class="column-headers">
              <div class="route-icon" title="{{ 'Route' | translate }}"><i class="fas fa-route"></i></div>
              <div class="flex-1 caption">{{ 'Line direction' | translate }}</div>
            </div>
            @for (
              result of lineSearchResults; track trackByKey.bind(this, 'id')($index,
              result)) {
              <input type="checkbox" [id]="'result-'+result.id" [checked]="result.selected">
              <div class="result" (click)="onClickToggleLineSearchResult(result)">
                <div class="route">{{ result.routeName }}</div>
                @if (result.firstStopDestinationSign) {
                  <div class="flex-1 caption">
                    {{ result.firstStopDestinationSign }}
                  </div>
                }
                @if (result.lineStopSearchLoader) {
                  <places-spinner></places-spinner>
                }
              </div>
            }
          </div>
        }
      }
      @if (shouldShowAffectedError) {
        <app-validation-message [control]="affectedControl"></app-validation-message>
      }
    </div>
  </fieldset>
}

  <app-selected-line></app-selected-line>
  <app-selected-stops></app-selected-stops>